/**
 * Dashboard Hooks
 * TanStack Query hooks for dashboard data
 */

import { useQuery } from '@tanstack/react-query'
import { getDashboardStats } from '@/services/dashboard.service'
import type { DashboardStats } from '@/types/dashboard'

/**
 * Hook to fetch dashboard statistics
 * GET /dashboard/admin
 */
export const useDashboardStats = () => {
    return useQuery<DashboardStats>({
        queryKey: ['dashboard', 'stats'],
        queryFn: getDashboardStats,
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
    })
}
